<div class="templateBody">

  <!-- Top Buttons -->
  <div class="d-flex flex-column align-items-end mb-3">
    <button type="button" class="btn btn-sm btn-primary mb-2" title="Export to CSV" (click)="exportSubmission()">
      <i class="fa fa-file-export me-1"></i> Export
    </button>

    <button *ngIf="showArchiveButton" type="button" class="btn btn-sm btn-secondary mb-2" title="View Archived Submissions" (click)="archiveSubmission()">
      <i class="fa fa-archive me-1"></i> View Archive
    </button>

    <button *ngIf="showCloseButton" type="button" class="btn btn-sm btn-secondary" title="Return to Submission List" (click)="returntoSubmission()">
      <i class="fa fa-times me-1"></i> Close Archive
    </button>
  </div>

  <p-table
  #tt
  [value]="shownSubmissions"
  [paginator]="true"
  [rows]="rowCount"
  [rowHover]="true"
  [resizableColumns]="true"
  styleClass="p-datatable-sm p-datatable-gridlines custom-table"
  sortField="createdAt"
  [sortOrder]="-1"
  [globalFilterFields]="globalFilterFields">

  <!-- Caption -->
  <ng-template pTemplate="caption">
    <div class="table-toolbar">
      <div class="left">
        Show
        <p-select
        [options]="entries"
          optionLabel="val"
          placeholder="50"
          [(ngModel)]="rowCountReset"
          (onChange)="updateRowCount($event)"
          [style]="{ width: '50px'}"
          [panelStyle]="{ 'background-color': '#fff', 'border': '1px solid #dcdcdc' }">
        </p-select>
        Entries
      </div>


    <div class="right">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon">
          <i class="pi pi-search"></i>
        </span>

        <input #searchTxt 
              pInputText
              placeholder="   Search"
              (input)="tt.filterGlobal($event.target.value, 'contains')" />
      </div>

      <button class="p-button-outlined p-component" icon="pi pi-refresh" (click)="resetSubList()">
        <span class="p-button-label">Reset</span>
      </button>

    </div>

    </div>
  </ng-template>

  <!-- Header -->
<ng-template pTemplate="header">
  <tr>
    <th *ngFor="let col of cols"
        pSortableColumn="{{ col.field }}"
        class="text-center">

      <div>{{ col.header }}</div>
      <p-sortIcon [field]="col.field"></p-sortIcon>

      <!-- <p-columnFilter
        [type]="col.isDate ? 'date' : col.isNumeric ? 'numeric' : 'text'"
        [field]="col.field"
        display="menu">
      </p-columnFilter> -->
      
<!-- Built-in column filter for PrimeNG 19 -->
<p-columnFilter 
  [field]="col.field" 
  [type]="col.isDate ? 'date' : col.isNumeric ? 'numeric' : 'text'" 
  display="menu">

  <!-- TEXT FILTER -->
  <ng-template *ngIf="!col.isDate && !col.isNumeric && !col.isServiceCenter && !col.isWorkflow"
               pTemplate="menu" 
               let-value let-filter="filterCallback">
    <div class="p-fluid p-2">
      <input pInputText
             [ngModel]="value"
             (ngModelChange)="filter($event)"
             placeholder="Filter..." class="w-100">
    </div>
  </ng-template>

  <!-- NUMERIC FILTER -->
  <ng-template *ngIf="col.isNumeric"
               pTemplate="menu"
               let-value let-filter="filterCallback">
    <div class="p-fluid p-2">
      <input type="number"
             pInputText
             [ngModel]="value"
             (ngModelChange)="filter($event)">
    </div>
  </ng-template>

  <!-- DATE FILTER -->
  <ng-template *ngIf="col.isDate"
               pTemplate="menu"
               let-value let-filter="filterCallback">
    <div class="p-fluid p-2">
      <p-datepicker
        [ngModel]="value"
        (ngModelChange)="filter($event)"
        dateFormat="mm/dd/yy"
        showIcon="true">
      </p-datepicker>
    </div>
  </ng-template>

  <!-- DROPDOWN (Service Center / Workflow) -->
  <ng-template *ngIf="col.isServiceCenter || col.isWorkflow"
               pTemplate="menu"
               let-value let-filter="filterCallback">
    <div class="p-fluid p-2">
      <p-select
        [options]="col.isServiceCenter ? centerLabels : workflowLabels"
        optionLabel="label"
        optionValue="value"
        [ngModel]="value"
        (ngModelChange)="filter($event)"
        placeholder="Any">
      </p-select>
    </div>
  </ng-template>

</p-columnFilter>

    </th>
    <th class="text-center">Action</th>
  </tr>
</ng-template>

  <ng-template pTemplate="body" let-sub>
    <tr>
      <td *ngFor="let col of cols">
        {{ col.isDate ? (sub[col.field] | date:'MM/dd/yy') : sub[col.field] }}
      </td>
      <td>
        <a class="d-block" [routerLink]="['/viewsubmission', sub.submissionId]">View</a>
        <a class="d-block" *ngIf="sub.canEdit" [routerLink]="['/editsubmission', sub.submissionId]">Edit</a>
      </td>
    </tr>
  </ng-template>


</p-table>


</div>


